// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1gwhG","itemTitle":"ClientEmergencyInfo_itemTitle__3a7pV","itemText":"ClientEmergencyInfo_itemText__2KaNy"};